<template>
  <section class="timeline-items">
    <div class="item" v-for="(item, index) in itemsTimeline" :key="index">
      <span class="dot" :style="{ background: item.color }"/>
      <h3 class="month-item">{{ item.time }}</h3>
      <div class="right-item">
        <h4 class="title-item" v-html="item.title"></h4>
        <p class="description-item" v-html="item.description"></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TimelineItem',
  props: {
    itemsTimeline: {
      type: Array,
      default: () => []
    },
    colorDots: {
      type: String,
      default: '#00af00'
    }
  }
};
</script>

<style scoped>
.timeline-items .item {
  border-left: 2px solid #dadadb;
  padding: 8px 0 8px 16px;
  position: relative;
}
.timeline-items .right-item {
  background: white;
  padding-left: 15px;
  padding-bottom: 5px;
  border-radius: 4px;
  border: 1px solid #dadadb;
}
.timeline-items .month-item {
  margin: 3px 0px 0px -75px;
  font-size: 18px;
  position: absolute;
}
.timeline-items .title-item {
  margin: 0;
  padding: 5px 0;
  font-size: 16px;
  font-weight: 500;
}
.timeline-items .description-item {
  font-weight: 100;
  margin: 0;
}
.timeline-items .dot {
  display: block;
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  left: -6px;
  top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Timeline/TimelineItem.vue